import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { AxiosPromise, AxiosRequestConfig } from 'axios';

import { api } from '@/api';

export async function getZammadQuotes(
  params: openapi.GetZammadQuotes_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetZammadQuotes_200> {
  return await api.get<openapi.GetZammadQuotes_200>('/zammad/quotes/', {
    ...requestConfig,
    params,
  });
}

export async function postZammadTickets(
  params: openapi.JobCreateTicketQueryOpenapi,
  data: openapi.JobCreateTicketBodyOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.JobCreateTicketContentOpenapi> {
  return await api.post<openapi.JobCreateTicketContentOpenapi>(
    '/zammad/tickets/',
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getZammadLookupEmail(
  params: openapi.ZammadLookupEmailQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.ZammadLookupEmailContentOpenapi> {
  return await api.get<openapi.ZammadLookupEmailContentOpenapi>(
    '/zammad/lookup/email', // NOTE no trailing slash
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getZammadChannelsEmails(
  params: openapi.ZammadChannelsEmailsQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.ZammadChannelsEmailsContentOpenapi> {
  return await api.get<openapi.ZammadChannelsEmailsContentOpenapi>(
    '/zammad/channels-emails/',
    {
      ...requestConfig,
      params,
    },
  );
}
